export enum Storage {
  API_TOKEN = 'API_TOKEN',
  CURRENT_LEARNING_COMMUNITY = 'CURRENT_LEARNING_COMMUNITY',
  CURRENT_COHORT_ID = 'CURRENT_COHORT_ID',
  APPLY_USER_DATA = 'APPLY_USER_DATA',
  APPLY_APPLICATION_DATA = 'APPLY_APPLICATION_DATA',
  SHARE_PROFILE_CARD_DISMISSED = 'SHARE_PROFILE_CARD_DISMISSED',
  CANT_MAKE_IT_FOR_DYNAMIC_SQUADS_IN_SECTIONS = 'CANT_MAKE_IT_FOR_DYNAMIC_SQUADS_IN_SECTIONS',
}
